import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EndCorrectionFactors, SeveritySelected } from 'src/app/helpers';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';

declare var Gauge: any;

@Component({
  selector: 'app-common-rating-grading',
  templateUrl: './grading.component.html',
  styleUrls: ['./grading.component.scss'],
})
export class GradingComponent implements OnInit {
  public loaded: boolean = false;
  public lang: string = null;

  public gradePV: string | number = null;
  public gradeCV: string | number = null;
  public extOverall: number = null;
  public intOverall: number = null;
  public frameOverall: number = null;
  public mecOverall: number = null;
  public majorOptOverall: number = null;

  public selectedSeverity: SeveritySelected = {
    exterior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    interior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    mechanics: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    frame: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
    major_options: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null,
      },
      endCorrection: {},
    },
  };

  public endCorrectionFactors: EndCorrectionFactors[] = [];

  public vinInfo: Object = {};

  public subscriptions: Subscription[] = [];

  constructor(
    public sharedService: SharedService,
    public ratingService: RatingService,
    public localeServive: LocaleService
  ) {}

  ngOnInit(): void {
    this.getVinInfo();
    this.getLocale();
    this.getState();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  getVinInfo() {
    const infoSub = this.sharedService.vinInformation.subscribe((res) => {
      if (res) {
        this.vinInfo = res;
      }
    });
    this.subscriptions.push(infoSub);
  }

  getLocale() {
    const localeSub = this.localeServive.localeSubject.subscribe((res) => {
      if (res) {
        this.lang = res;
      }
    });
    this.subscriptions.push(localeSub);
  }

  // Getting state data
  getState() {
    let data: object = { vehicle_id: this.sharedService.getVehicleId };

    const stateSub = this.ratingService.getRatingStates(data).subscribe(
      (res) => {
        if (res) {
          let success: boolean = res['success'];
          let data: object = res['data'];

          if (success && Object.keys(data).length) {
            const states: SeveritySelected = data['ratingStates']
              ? JSON.parse(data['ratingStates']['rating_states'])
              : null;
            // let interiorEC: object = states ? states.interior.endCorrection : {};
            // let frameEC: object = states ? states.frame.endCorrection : {};

            this.selectedSeverity = states;
            this.extOverall = +(states
              ? states['exterior']['overall']['rating'] ?? 5
              : 5);
            this.intOverall = +(states
              ? states['interior']['overall']['rating'] ?? 5
              : 5);
            this.mecOverall = +(states
              ? states['mechanics']['overall']['rating'] ?? 5
              : 5);
            this.frameOverall = +(states
              ? states['frame']['overall']['rating'] ?? 5
              : 5);
            this.majorOptOverall = +(states
              ? states['major_options']['overall']['rating'] ?? 5
              : 5);

            setTimeout(() => {
              this.gradeCV =
                this.extOverall * 0.5 +
                this.intOverall * 0.1 +
                this.mecOverall * 0.3 +
                this.frameOverall * 0.05 +
                this.majorOptOverall * 0.05;
              this.gradeCV = this.gradeCV > 5 ? 5 : this.gradeCV;
              // this.gradeCV = +(+this.gradeCV).toFixed(1);

              this.endCorrection(this.gradeCV);
            }, 0);
          }
            }
      },
      (error: HttpErrorResponse) => {}
    );

    this.subscriptions.push(stateSub);
  }

  endCorrection(grade: number) {
    let milage: object =
      this.vinInfo && this.vinInfo['odo'] ? this.vinInfo['odo'] : null;
    this.endCorrectionFactors = [];

    if (grade >= 4 && +milage['value'] > 100000) {
      this.endCorrectionFactors.push({
        factor: 'Odo',
        selectedCondition: [],
        value: milage['value'],
      });
      this.gradePV = 3.9;
    }

    if (this.selectedSeverity) {
      let interior: Object = this.selectedSeverity.interior.endCorrection;
      let frame: Object = this.selectedSeverity.frame.endCorrection;
      let mechanics: Object = this.selectedSeverity.mechanics.endCorrection;

      if (Object.keys(interior).length && interior) {
        let airBagSeverityLvl: number | string =
          interior['air_bag'].severity_level;
        let airBagCondition: object[] = interior['air_bag'].selected_condition;

        if (grade >= 3.4) {
          if (+airBagSeverityLvl === 1) {
            this.endCorrectionFactors.push({
              factor: 'Air bag',
              selectedCondition: airBagCondition,
              value: `Severity Level: ${+airBagSeverityLvl}`,
            });
            this.gradePV = 3.4;
          }
        }
      }

      if (Object.keys(mechanics).length && mechanics) {
        for (let prop in mechanics) {
          if (grade >= 4) {
            let severityLvl: number | string = mechanics[prop].severity_level;
            let condition: object[] = mechanics[prop].selected_condition;

            if (+severityLvl < 3) {
              this.endCorrectionFactors.push({
                factor: prop.toLowerCase().replace(new RegExp('_', 'g'), ''),
                selectedCondition: condition,
                value: `Severity Level: ${+severityLvl}`,
              });
              this.gradePV = 3.9;
            }
          }
        }
      }

      if (Object.keys(frame).length && frame) {
        for (let prop in frame) {
          if (grade >= 2.4) {
            let severityLvl: number | string = frame[prop].severity_level;
            let condition: object[] = frame[prop].selected_condition;

            if (+severityLvl < 3) {
              this.endCorrectionFactors.push({
                factor: prop.toLowerCase().replace(new RegExp('_', 'g'), ' '),
                selectedCondition: condition,
                value: `Severity Level: ${+severityLvl}`,
              });
              this.gradePV = 2.4;
            }
          }
        }
      }
    }

    this.gradePV = +(+this.gradePV).toFixed(1);
    this.initGauge(grade, this.gradePV);
  }

  initGauge(gradeCV: number, gradePV: number) {
    //Implementing gauge to show the grading scale
    let target = document.querySelector('#gauge');
    let settings = {
      angle: 0, // The span of the gauge arc
      lineWidth: 0.3, // The line thickness
      radiusScale: 1, // Relative radius
      pointer: {
        length: 0.4, // // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: '#222222', // Fill color
      },
      limitMax: false, // If false, max value increases automatically if value > maxValue
      limitMin: false, // If true, the min value of the gauge will be fixed
      colorStart: '#6FADCF', // Colors
      colorStop: '#8FC0DA', // just experiment with them
      strokeColor: '#E0E0E0', // to see which ones work best for you
      generateGradient: true,
      highDpiSupport: true, // High resolution support
      staticZones: [
        { strokeStyle: '#ff3300', min: 1, max: 1.48 },
        { strokeStyle: '#ff6600', min: 1.48, max: 1.98 },
        { strokeStyle: '#ff9900', min: 1.98, max: 2.48 },
        { strokeStyle: '#ffcc00', min: 2.48, max: 2.98 },
        { strokeStyle: '#ffff99', min: 2.98, max: 3.48 },
        { strokeStyle: '#c6e0b4', min: 3.48, max: 3.98 },
        { strokeStyle: '#a9d08e', min: 3.98, max: 4.48 },
        { strokeStyle: '#548235', min: 4.48, max: 4.98 },
        { strokeStyle: '#375623', min: 4.98, max: 5 },
      ],
    };
    let gaugeCV = new Gauge(target, 150, 350).setOptions(settings);
    // gradeCV = +gradeCV.toFixed(3);

    gaugeCV.maxValue = 5; // set max gauge value
    gaugeCV.setMinValue(1); // Prefer setter over gauge.minValue = 0
    gaugeCV.animationSpeed = 92; // set animation speed (32 is default value)
    gaugeCV.set(gradeCV);

    if (gradePV > 0) {
      setTimeout(() => {
        let target2 = document.querySelector('#gauge2');
        let gaugePV = new Gauge(target2, 150, 350).setOptions(settings);

        gaugePV.maxValue = 5; // set max gauge value
        gaugePV.setMinValue(1); // Prefer setter over gauge.minValue = 0
        gaugePV.animationSpeed = 92; // set animation speed (32 is default value)
        gaugePV.set(gradePV);
      }, 0);
    }
  }
}
